// extracted by mini-css-extract-plugin
module.exports = {"buttons":"buttons-vu-Cf","button":"button-2YKO7","back":"back-1URHi"};